import { SVGProps } from 'react';

export function DragHandleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d="M4 15v-2h16v2H4Zm0-4V9h16v2H4Z"></path>
    </svg>
  );
}
